/**
 * @file 工具页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import ToolList from './components/tool-list/ToolList';

import useToolsHooks from './toolsHooks';

const Tools: React.FC = () => {
    const toolList = useToolsHooks().toolList;

    return (
        <div className="page paddle-tools-page">
            <Header />
            <Banner
                title="工具"
                subtitle="加速您的深度学习项目"
                divider
            />
            <div className="paddle-tools-page-container">
                <ToolList toolList={toolList} />
            </div>
            <Footer />
        </div>
    );
};

export default Tools;
